import { useState } from 'react';
import { Link } from 'react-router-dom';
import { SiteHeader } from '../../components/layout/SiteHeader';
import { Button } from '../../components/ui/Button';
import { Input, Label } from '../../components/ui/Input';
import { authClient } from '../../auth/client';
import { t } from '../../i18n';
import './auth-page.css';

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitting(true);
    setError(null);
    const result = await authClient.requestPasswordReset(email);
    setSubmitting(false);
    if (result.ok) {
      // Same success state regardless of whether the address exists, to
      // avoid leaking account existence.
      setSent(true);
      return;
    }
    if (result.offline) {
      setError(t('auth.errors.network'));
    } else {
      setError(t('auth.errors.generic'));
    }
  };

  return (
    <div className="page-shell">
      <SiteHeader />
      <div className="centered-page">
        <div className="auth-card">
          <h1>{t('auth.forgotPassword.title')}</h1>
          <p className="auth-card-subtitle">{t('auth.forgotPassword.subtitle')}</p>

          {sent ? <div className="auth-success">{t('auth.forgotPassword.sent')}</div> : null}
          {error ? <div className="auth-error">{error}</div> : null}

          {!sent ? (
            <form className="auth-form" onSubmit={handleSubmit}>
              <div className="field-group">
                <Label htmlFor="email">{t('auth.forgotPassword.email')}</Label>
                <Input
                  id="email"
                  type="email"
                  autoComplete="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
              <Button type="submit" variant="primary" size="lg" disabled={submitting}>
                {submitting ? t('common.loading') : t('auth.forgotPassword.submit')}
              </Button>
            </form>
          ) : null}

          <div className="auth-footer">
            <Link to="/login">{t('auth.forgotPassword.backToLogin')}</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
